import it, { forwardRef as ut, useRef as Ar, useMemo as jr, useEffect as Dn, useImperativeHandle as Fn } from "react";
import Mn from "muuri";
var De = {}, Nn = {
  get exports() {
    return De;
  },
  set exports(e) {
    De = e;
  }
}, re = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xr;
function Ln() {
  if (xr)
    return re;
  xr = 1;
  var e = it, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(c, l, y) {
    var p, T = {}, w = null, C = null;
    y !== void 0 && (w = "" + y), l.key !== void 0 && (w = "" + l.key), l.ref !== void 0 && (C = l.ref);
    for (p in l)
      a.call(l, p) && !u.hasOwnProperty(p) && (T[p] = l[p]);
    if (c && c.defaultProps)
      for (p in l = c.defaultProps, l)
        T[p] === void 0 && (T[p] = l[p]);
    return { $$typeof: r, type: c, key: w, ref: C, props: T, _owner: o.current };
  }
  return re.Fragment = t, re.jsx = f, re.jsxs = f, re;
}
var te = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function Un() {
  return Ir || (Ir = 1, process.env.NODE_ENV !== "production" && function() {
    var e = it, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), G = Symbol.iterator, ce = "@@iterator";
    function j(n) {
      if (n === null || typeof n != "object")
        return null;
      var i = G && n[G] || n[ce];
      return typeof i == "function" ? i : null;
    }
    var R = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(n) {
      {
        for (var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), d = 1; d < i; d++)
          s[d - 1] = arguments[d];
        en("error", n, s);
      }
    }
    function en(n, i, s) {
      {
        var d = R.ReactDebugCurrentFrame, h = d.getStackAddendum();
        h !== "" && (i += "%s", s = s.concat([h]));
        var b = s.map(function(v) {
          return String(v);
        });
        b.unshift("Warning: " + i), Function.prototype.apply.call(console[n], console, b);
      }
    }
    var rn = !1, tn = !1, nn = !1, an = !1, on = !1, ir;
    ir = Symbol.for("react.module.reference");
    function un(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === a || n === u || on || n === o || n === y || n === p || an || n === C || rn || tn || nn || typeof n == "object" && n !== null && (n.$$typeof === w || n.$$typeof === T || n.$$typeof === f || n.$$typeof === c || n.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === ir || n.getModuleId !== void 0));
    }
    function sn(n, i, s) {
      var d = n.displayName;
      if (d)
        return d;
      var h = i.displayName || i.name || "";
      return h !== "" ? s + "(" + h + ")" : s;
    }
    function ur(n) {
      return n.displayName || "Context";
    }
    function F(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case a:
          return "Fragment";
        case t:
          return "Portal";
        case u:
          return "Profiler";
        case o:
          return "StrictMode";
        case y:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case c:
            var i = n;
            return ur(i) + ".Consumer";
          case f:
            var s = n;
            return ur(s._context) + ".Provider";
          case l:
            return sn(n, n.render, "ForwardRef");
          case T:
            var d = n.displayName || null;
            return d !== null ? d : F(n.type) || "Memo";
          case w: {
            var h = n, b = h._payload, v = h._init;
            try {
              return F(v(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, Q = 0, sr, fr, cr, lr, dr, gr, pr;
    function vr() {
    }
    vr.__reactDisabledLog = !0;
    function fn() {
      {
        if (Q === 0) {
          sr = console.log, fr = console.info, cr = console.warn, lr = console.error, dr = console.group, gr = console.groupCollapsed, pr = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: vr,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        Q++;
      }
    }
    function cn() {
      {
        if (Q--, Q === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, n, {
              value: sr
            }),
            info: B({}, n, {
              value: fr
            }),
            warn: B({}, n, {
              value: cr
            }),
            error: B({}, n, {
              value: lr
            }),
            group: B({}, n, {
              value: dr
            }),
            groupCollapsed: B({}, n, {
              value: gr
            }),
            groupEnd: B({}, n, {
              value: pr
            })
          });
        }
        Q < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $e = R.ReactCurrentDispatcher, Oe;
    function le(n, i, s) {
      {
        if (Oe === void 0)
          try {
            throw Error();
          } catch (h) {
            var d = h.stack.trim().match(/\n( *(at )?)/);
            Oe = d && d[1] || "";
          }
        return `
` + Oe + n;
      }
    }
    var we = !1, de;
    {
      var ln = typeof WeakMap == "function" ? WeakMap : Map;
      de = new ln();
    }
    function hr(n, i) {
      if (!n || we)
        return "";
      {
        var s = de.get(n);
        if (s !== void 0)
          return s;
      }
      var d;
      we = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = $e.current, $e.current = null, fn();
      try {
        if (i) {
          var v = function() {
            throw Error();
          };
          if (Object.defineProperty(v.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(v, []);
            } catch (M) {
              d = M;
            }
            Reflect.construct(n, [], v);
          } else {
            try {
              v.call();
            } catch (M) {
              d = M;
            }
            n.call(v.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (M) {
            d = M;
          }
          n();
        }
      } catch (M) {
        if (M && d && typeof M.stack == "string") {
          for (var g = M.stack.split(`
`), O = d.stack.split(`
`), E = g.length - 1, S = O.length - 1; E >= 1 && S >= 0 && g[E] !== O[S]; )
            S--;
          for (; E >= 1 && S >= 0; E--, S--)
            if (g[E] !== O[S]) {
              if (E !== 1 || S !== 1)
                do
                  if (E--, S--, S < 0 || g[E] !== O[S]) {
                    var P = `
` + g[E].replace(" at new ", " at ");
                    return n.displayName && P.includes("<anonymous>") && (P = P.replace("<anonymous>", n.displayName)), typeof n == "function" && de.set(n, P), P;
                  }
                while (E >= 1 && S >= 0);
              break;
            }
        }
      } finally {
        we = !1, $e.current = b, cn(), Error.prepareStackTrace = h;
      }
      var J = n ? n.displayName || n.name : "", Cr = J ? le(J) : "";
      return typeof n == "function" && de.set(n, Cr), Cr;
    }
    function dn(n, i, s) {
      return hr(n, !1);
    }
    function gn(n) {
      var i = n.prototype;
      return !!(i && i.isReactComponent);
    }
    function ge(n, i, s) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return hr(n, gn(n));
      if (typeof n == "string")
        return le(n);
      switch (n) {
        case y:
          return le("Suspense");
        case p:
          return le("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case l:
            return dn(n.render);
          case T:
            return ge(n.type, i, s);
          case w: {
            var d = n, h = d._payload, b = d._init;
            try {
              return ge(b(h), i, s);
            } catch {
            }
          }
        }
      return "";
    }
    var pe = Object.prototype.hasOwnProperty, br = {}, yr = R.ReactDebugCurrentFrame;
    function ve(n) {
      if (n) {
        var i = n._owner, s = ge(n.type, n._source, i ? i.type : null);
        yr.setExtraStackFrame(s);
      } else
        yr.setExtraStackFrame(null);
    }
    function pn(n, i, s, d, h) {
      {
        var b = Function.call.bind(pe);
        for (var v in n)
          if (b(n, v)) {
            var g = void 0;
            try {
              if (typeof n[v] != "function") {
                var O = Error((d || "React class") + ": " + s + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              g = n[v](i, v, d, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (E) {
              g = E;
            }
            g && !(g instanceof Error) && (ve(h), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", s, v, typeof g), ve(null)), g instanceof Error && !(g.message in br) && (br[g.message] = !0, ve(h), $("Failed %s type: %s", s, g.message), ve(null));
          }
      }
    }
    var vn = Array.isArray;
    function Re(n) {
      return vn(n);
    }
    function hn(n) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, s = i && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return s;
      }
    }
    function bn(n) {
      try {
        return mr(n), !1;
      } catch {
        return !0;
      }
    }
    function mr(n) {
      return "" + n;
    }
    function _r(n) {
      if (bn(n))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(n)), mr(n);
    }
    var ee = R.ReactCurrentOwner, yn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Tr, Er, Pe;
    Pe = {};
    function mn(n) {
      if (pe.call(n, "ref")) {
        var i = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function _n(n) {
      if (pe.call(n, "key")) {
        var i = Object.getOwnPropertyDescriptor(n, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function Tn(n, i) {
      if (typeof n.ref == "string" && ee.current && i && ee.current.stateNode !== i) {
        var s = F(ee.current.type);
        Pe[s] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', F(ee.current.type), n.ref), Pe[s] = !0);
      }
    }
    function En(n, i) {
      {
        var s = function() {
          Tr || (Tr = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        s.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function Sn(n, i) {
      {
        var s = function() {
          Er || (Er = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        s.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var $n = function(n, i, s, d, h, b, v) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: n,
        key: i,
        ref: s,
        props: v,
        // Record the component responsible for creating this element.
        _owner: b
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function On(n, i, s, d, h) {
      {
        var b, v = {}, g = null, O = null;
        s !== void 0 && (_r(s), g = "" + s), _n(i) && (_r(i.key), g = "" + i.key), mn(i) && (O = i.ref, Tn(i, h));
        for (b in i)
          pe.call(i, b) && !yn.hasOwnProperty(b) && (v[b] = i[b]);
        if (n && n.defaultProps) {
          var E = n.defaultProps;
          for (b in E)
            v[b] === void 0 && (v[b] = E[b]);
        }
        if (g || O) {
          var S = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          g && En(v, S), O && Sn(v, S);
        }
        return $n(n, g, O, h, d, ee.current, v);
      }
    }
    var Ce = R.ReactCurrentOwner, Sr = R.ReactDebugCurrentFrame;
    function q(n) {
      if (n) {
        var i = n._owner, s = ge(n.type, n._source, i ? i.type : null);
        Sr.setExtraStackFrame(s);
      } else
        Sr.setExtraStackFrame(null);
    }
    var Ae;
    Ae = !1;
    function je(n) {
      return typeof n == "object" && n !== null && n.$$typeof === r;
    }
    function $r() {
      {
        if (Ce.current) {
          var n = F(Ce.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function wn(n) {
      {
        if (n !== void 0) {
          var i = n.fileName.replace(/^.*[\\\/]/, ""), s = n.lineNumber;
          return `

Check your code at ` + i + ":" + s + ".";
        }
        return "";
      }
    }
    var Or = {};
    function Rn(n) {
      {
        var i = $r();
        if (!i) {
          var s = typeof n == "string" ? n : n.displayName || n.name;
          s && (i = `

Check the top-level render call using <` + s + ">.");
        }
        return i;
      }
    }
    function wr(n, i) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var s = Rn(i);
        if (Or[s])
          return;
        Or[s] = !0;
        var d = "";
        n && n._owner && n._owner !== Ce.current && (d = " It was passed a child from " + F(n._owner.type) + "."), q(n), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, d), q(null);
      }
    }
    function Rr(n, i) {
      {
        if (typeof n != "object")
          return;
        if (Re(n))
          for (var s = 0; s < n.length; s++) {
            var d = n[s];
            je(d) && wr(d, i);
          }
        else if (je(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var h = j(n);
          if (typeof h == "function" && h !== n.entries)
            for (var b = h.call(n), v; !(v = b.next()).done; )
              je(v.value) && wr(v.value, i);
        }
      }
    }
    function Pn(n) {
      {
        var i = n.type;
        if (i == null || typeof i == "string")
          return;
        var s;
        if (typeof i == "function")
          s = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === T))
          s = i.propTypes;
        else
          return;
        if (s) {
          var d = F(i);
          pn(s, n.props, "prop", d, n);
        } else if (i.PropTypes !== void 0 && !Ae) {
          Ae = !0;
          var h = F(i);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", h || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Cn(n) {
      {
        for (var i = Object.keys(n.props), s = 0; s < i.length; s++) {
          var d = i[s];
          if (d !== "children" && d !== "key") {
            q(n), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), q(null);
            break;
          }
        }
        n.ref !== null && (q(n), $("Invalid attribute `ref` supplied to `React.Fragment`."), q(null));
      }
    }
    function Pr(n, i, s, d, h, b) {
      {
        var v = un(n);
        if (!v) {
          var g = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = wn(h);
          O ? g += O : g += $r();
          var E;
          n === null ? E = "null" : Re(n) ? E = "array" : n !== void 0 && n.$$typeof === r ? (E = "<" + (F(n.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : E = typeof n, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, g);
        }
        var S = On(n, i, s, h, b);
        if (S == null)
          return S;
        if (v) {
          var P = i.children;
          if (P !== void 0)
            if (d)
              if (Re(P)) {
                for (var J = 0; J < P.length; J++)
                  Rr(P[J], n);
                Object.freeze && Object.freeze(P);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Rr(P, n);
        }
        return n === a ? Cn(S) : Pn(S), S;
      }
    }
    function An(n, i, s) {
      return Pr(n, i, s, !0);
    }
    function jn(n, i, s) {
      return Pr(n, i, s, !1);
    }
    var xn = jn, In = An;
    te.Fragment = a, te.jsx = xn, te.jsxs = In;
  }()), te;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Ln() : e.exports = Un();
})(Nn);
const Fe = De.jsx;
function st(e) {
  var r, t, a = "";
  if (typeof e == "string" || typeof e == "number")
    a += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (r = 0; r < e.length; r++)
        e[r] && (t = st(e[r])) && (a && (a += " "), a += t);
    else
      for (r in e)
        e[r] && (a && (a += " "), a += r);
  return a;
}
function Me() {
  for (var e, r, t = 0, a = ""; t < arguments.length; )
    (e = arguments[t++]) && (r = st(e)) && (a && (a += " "), a += r);
  return a;
}
var Gn = typeof global == "object" && global && global.Object === Object && global;
const ft = Gn;
var Bn = typeof self == "object" && self && self.Object === Object && self, Wn = ft || Bn || Function("return this")();
const D = Wn;
var Yn = D.Symbol;
const x = Yn;
var ct = Object.prototype, zn = ct.hasOwnProperty, Hn = ct.toString, ne = x ? x.toStringTag : void 0;
function Vn(e) {
  var r = zn.call(e, ne), t = e[ne];
  try {
    e[ne] = void 0;
    var a = !0;
  } catch {
  }
  var o = Hn.call(e);
  return a && (r ? e[ne] = t : delete e[ne]), o;
}
var Kn = Object.prototype, qn = Kn.toString;
function Jn(e) {
  return qn.call(e);
}
var kn = "[object Null]", Xn = "[object Undefined]", Dr = x ? x.toStringTag : void 0;
function z(e) {
  return e == null ? e === void 0 ? Xn : kn : Dr && Dr in Object(e) ? Vn(e) : Jn(e);
}
function L(e) {
  return e != null && typeof e == "object";
}
var Zn = "[object Symbol]";
function He(e) {
  return typeof e == "symbol" || L(e) && z(e) == Zn;
}
function lt(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length, o = Array(a); ++t < a; )
    o[t] = r(e[t], t, e);
  return o;
}
var Qn = Array.isArray;
const A = Qn;
var ea = 1 / 0, Fr = x ? x.prototype : void 0, Mr = Fr ? Fr.toString : void 0;
function dt(e) {
  if (typeof e == "string")
    return e;
  if (A(e))
    return lt(e, dt) + "";
  if (He(e))
    return Mr ? Mr.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -ea ? "-0" : r;
}
function I(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
function Ve(e) {
  return e;
}
var ra = "[object AsyncFunction]", ta = "[object Function]", na = "[object GeneratorFunction]", aa = "[object Proxy]";
function Ke(e) {
  if (!I(e))
    return !1;
  var r = z(e);
  return r == ta || r == na || r == ra || r == aa;
}
var oa = D["__core-js_shared__"];
const xe = oa;
var Nr = function() {
  var e = /[^.]+$/.exec(xe && xe.keys && xe.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ia(e) {
  return !!Nr && Nr in e;
}
var ua = Function.prototype, sa = ua.toString;
function H(e) {
  if (e != null) {
    try {
      return sa.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var fa = /[\\^$.*+?()[\]{}|]/g, ca = /^\[object .+?Constructor\]$/, la = Function.prototype, da = Object.prototype, ga = la.toString, pa = da.hasOwnProperty, va = RegExp(
  "^" + ga.call(pa).replace(fa, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ha(e) {
  if (!I(e) || ia(e))
    return !1;
  var r = Ke(e) ? va : ca;
  return r.test(H(e));
}
function ba(e, r) {
  return e == null ? void 0 : e[r];
}
function V(e, r) {
  var t = ba(e, r);
  return ha(t) ? t : void 0;
}
var ya = V(D, "WeakMap");
const Ne = ya;
var Lr = Object.create, ma = function() {
  function e() {
  }
  return function(r) {
    if (!I(r))
      return {};
    if (Lr)
      return Lr(r);
    e.prototype = r;
    var t = new e();
    return e.prototype = void 0, t;
  };
}();
const _a = ma;
function Ta(e, r, t) {
  switch (t.length) {
    case 0:
      return e.call(r);
    case 1:
      return e.call(r, t[0]);
    case 2:
      return e.call(r, t[0], t[1]);
    case 3:
      return e.call(r, t[0], t[1], t[2]);
  }
  return e.apply(r, t);
}
function gt(e, r) {
  var t = -1, a = e.length;
  for (r || (r = Array(a)); ++t < a; )
    r[t] = e[t];
  return r;
}
var Ea = 800, Sa = 16, $a = Date.now;
function Oa(e) {
  var r = 0, t = 0;
  return function() {
    var a = $a(), o = Sa - (a - t);
    if (t = a, o > 0) {
      if (++r >= Ea)
        return arguments[0];
    } else
      r = 0;
    return e.apply(void 0, arguments);
  };
}
function wa(e) {
  return function() {
    return e;
  };
}
var Ra = function() {
  try {
    var e = V(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const be = Ra;
var Pa = be ? function(e, r) {
  return be(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: wa(r),
    writable: !0
  });
} : Ve;
const Ca = Pa;
var Aa = Oa(Ca);
const pt = Aa;
function vt(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length; ++t < a && r(e[t], t, e) !== !1; )
    ;
  return e;
}
var ja = 9007199254740991, xa = /^(?:0|[1-9]\d*)$/;
function ye(e, r) {
  var t = typeof e;
  return r = r ?? ja, !!r && (t == "number" || t != "symbol" && xa.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
function qe(e, r, t) {
  r == "__proto__" && be ? be(e, r, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[r] = t;
}
function me(e, r) {
  return e === r || e !== e && r !== r;
}
var Ia = Object.prototype, Da = Ia.hasOwnProperty;
function Je(e, r, t) {
  var a = e[r];
  (!(Da.call(e, r) && me(a, t)) || t === void 0 && !(r in e)) && qe(e, r, t);
}
function X(e, r, t, a) {
  var o = !t;
  t || (t = {});
  for (var u = -1, f = r.length; ++u < f; ) {
    var c = r[u], l = a ? a(t[c], e[c], c, t, e) : void 0;
    l === void 0 && (l = e[c]), o ? qe(t, c, l) : Je(t, c, l);
  }
  return t;
}
var Ur = Math.max;
function ht(e, r, t) {
  return r = Ur(r === void 0 ? e.length - 1 : r, 0), function() {
    for (var a = arguments, o = -1, u = Ur(a.length - r, 0), f = Array(u); ++o < u; )
      f[o] = a[r + o];
    o = -1;
    for (var c = Array(r + 1); ++o < r; )
      c[o] = a[o];
    return c[r] = t(f), Ta(e, this, c);
  };
}
function Fa(e, r) {
  return pt(ht(e, r, Ve), e + "");
}
var Ma = 9007199254740991;
function ke(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ma;
}
function se(e) {
  return e != null && ke(e.length) && !Ke(e);
}
function Na(e, r, t) {
  if (!I(t))
    return !1;
  var a = typeof r;
  return (a == "number" ? se(t) && ye(r, t.length) : a == "string" && r in t) ? me(t[r], e) : !1;
}
function La(e) {
  return Fa(function(r, t) {
    var a = -1, o = t.length, u = o > 1 ? t[o - 1] : void 0, f = o > 2 ? t[2] : void 0;
    for (u = e.length > 3 && typeof u == "function" ? (o--, u) : void 0, f && Na(t[0], t[1], f) && (u = o < 3 ? void 0 : u, o = 1), r = Object(r); ++a < o; ) {
      var c = t[a];
      c && e(r, c, a, u);
    }
    return r;
  });
}
var Ua = Object.prototype;
function Xe(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || Ua;
  return e === t;
}
function Ga(e, r) {
  for (var t = -1, a = Array(e); ++t < e; )
    a[t] = r(t);
  return a;
}
var Ba = "[object Arguments]";
function Gr(e) {
  return L(e) && z(e) == Ba;
}
var bt = Object.prototype, Wa = bt.hasOwnProperty, Ya = bt.propertyIsEnumerable, za = Gr(function() {
  return arguments;
}()) ? Gr : function(e) {
  return L(e) && Wa.call(e, "callee") && !Ya.call(e, "callee");
};
const oe = za;
function Ha() {
  return !1;
}
var yt = typeof exports == "object" && exports && !exports.nodeType && exports, Br = yt && typeof module == "object" && module && !module.nodeType && module, Va = Br && Br.exports === yt, Wr = Va ? D.Buffer : void 0, Ka = Wr ? Wr.isBuffer : void 0, qa = Ka || Ha;
const Ze = qa;
var Ja = "[object Arguments]", ka = "[object Array]", Xa = "[object Boolean]", Za = "[object Date]", Qa = "[object Error]", eo = "[object Function]", ro = "[object Map]", to = "[object Number]", no = "[object Object]", ao = "[object RegExp]", oo = "[object Set]", io = "[object String]", uo = "[object WeakMap]", so = "[object ArrayBuffer]", fo = "[object DataView]", co = "[object Float32Array]", lo = "[object Float64Array]", go = "[object Int8Array]", po = "[object Int16Array]", vo = "[object Int32Array]", ho = "[object Uint8Array]", bo = "[object Uint8ClampedArray]", yo = "[object Uint16Array]", mo = "[object Uint32Array]", _ = {};
_[co] = _[lo] = _[go] = _[po] = _[vo] = _[ho] = _[bo] = _[yo] = _[mo] = !0;
_[Ja] = _[ka] = _[so] = _[Xa] = _[fo] = _[Za] = _[Qa] = _[eo] = _[ro] = _[to] = _[no] = _[ao] = _[oo] = _[io] = _[uo] = !1;
function _o(e) {
  return L(e) && ke(e.length) && !!_[z(e)];
}
function Qe(e) {
  return function(r) {
    return e(r);
  };
}
var mt = typeof exports == "object" && exports && !exports.nodeType && exports, ae = mt && typeof module == "object" && module && !module.nodeType && module, To = ae && ae.exports === mt, Ie = To && ft.process, Eo = function() {
  try {
    var e = ae && ae.require && ae.require("util").types;
    return e || Ie && Ie.binding && Ie.binding("util");
  } catch {
  }
}();
const k = Eo;
var Yr = k && k.isTypedArray, So = Yr ? Qe(Yr) : _o;
const _t = So;
var $o = Object.prototype, Oo = $o.hasOwnProperty;
function Tt(e, r) {
  var t = A(e), a = !t && oe(e), o = !t && !a && Ze(e), u = !t && !a && !o && _t(e), f = t || a || o || u, c = f ? Ga(e.length, String) : [], l = c.length;
  for (var y in e)
    (r || Oo.call(e, y)) && !(f && // Safari 9 has enumerable `arguments.length` in strict mode.
    (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    u && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
    ye(y, l))) && c.push(y);
  return c;
}
function Et(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var wo = Et(Object.keys, Object);
const Ro = wo;
var Po = Object.prototype, Co = Po.hasOwnProperty;
function Ao(e) {
  if (!Xe(e))
    return Ro(e);
  var r = [];
  for (var t in Object(e))
    Co.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
function _e(e) {
  return se(e) ? Tt(e) : Ao(e);
}
function jo(e) {
  var r = [];
  if (e != null)
    for (var t in Object(e))
      r.push(t);
  return r;
}
var xo = Object.prototype, Io = xo.hasOwnProperty;
function Do(e) {
  if (!I(e))
    return jo(e);
  var r = Xe(e), t = [];
  for (var a in e)
    a == "constructor" && (r || !Io.call(e, a)) || t.push(a);
  return t;
}
function fe(e) {
  return se(e) ? Tt(e, !0) : Do(e);
}
var Fo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Mo = /^\w*$/;
function No(e, r) {
  if (A(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || He(e) ? !0 : Mo.test(e) || !Fo.test(e) || r != null && e in Object(r);
}
var Lo = V(Object, "create");
const ie = Lo;
function Uo() {
  this.__data__ = ie ? ie(null) : {}, this.size = 0;
}
function Go(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var Bo = "__lodash_hash_undefined__", Wo = Object.prototype, Yo = Wo.hasOwnProperty;
function zo(e) {
  var r = this.__data__;
  if (ie) {
    var t = r[e];
    return t === Bo ? void 0 : t;
  }
  return Yo.call(r, e) ? r[e] : void 0;
}
var Ho = Object.prototype, Vo = Ho.hasOwnProperty;
function Ko(e) {
  var r = this.__data__;
  return ie ? r[e] !== void 0 : Vo.call(r, e);
}
var qo = "__lodash_hash_undefined__";
function Jo(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = ie && r === void 0 ? qo : r, this;
}
function Y(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var a = e[r];
    this.set(a[0], a[1]);
  }
}
Y.prototype.clear = Uo;
Y.prototype.delete = Go;
Y.prototype.get = zo;
Y.prototype.has = Ko;
Y.prototype.set = Jo;
function ko() {
  this.__data__ = [], this.size = 0;
}
function Te(e, r) {
  for (var t = e.length; t--; )
    if (me(e[t][0], r))
      return t;
  return -1;
}
var Xo = Array.prototype, Zo = Xo.splice;
function Qo(e) {
  var r = this.__data__, t = Te(r, e);
  if (t < 0)
    return !1;
  var a = r.length - 1;
  return t == a ? r.pop() : Zo.call(r, t, 1), --this.size, !0;
}
function ei(e) {
  var r = this.__data__, t = Te(r, e);
  return t < 0 ? void 0 : r[t][1];
}
function ri(e) {
  return Te(this.__data__, e) > -1;
}
function ti(e, r) {
  var t = this.__data__, a = Te(t, e);
  return a < 0 ? (++this.size, t.push([e, r])) : t[a][1] = r, this;
}
function N(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var a = e[r];
    this.set(a[0], a[1]);
  }
}
N.prototype.clear = ko;
N.prototype.delete = Qo;
N.prototype.get = ei;
N.prototype.has = ri;
N.prototype.set = ti;
var ni = V(D, "Map");
const ue = ni;
function ai() {
  this.size = 0, this.__data__ = {
    hash: new Y(),
    map: new (ue || N)(),
    string: new Y()
  };
}
function oi(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
function Ee(e, r) {
  var t = e.__data__;
  return oi(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
function ii(e) {
  var r = Ee(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
function ui(e) {
  return Ee(this, e).get(e);
}
function si(e) {
  return Ee(this, e).has(e);
}
function fi(e, r) {
  var t = Ee(this, e), a = t.size;
  return t.set(e, r), this.size += t.size == a ? 0 : 1, this;
}
function U(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var a = e[r];
    this.set(a[0], a[1]);
  }
}
U.prototype.clear = ai;
U.prototype.delete = ii;
U.prototype.get = ui;
U.prototype.has = si;
U.prototype.set = fi;
var ci = "Expected a function";
function er(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(ci);
  var t = function() {
    var a = arguments, o = r ? r.apply(this, a) : a[0], u = t.cache;
    if (u.has(o))
      return u.get(o);
    var f = e.apply(this, a);
    return t.cache = u.set(o, f) || u, f;
  };
  return t.cache = new (er.Cache || U)(), t;
}
er.Cache = U;
var li = 500;
function di(e) {
  var r = er(e, function(a) {
    return t.size === li && t.clear(), a;
  }), t = r.cache;
  return r;
}
var gi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, pi = /\\(\\)?/g, vi = di(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(gi, function(t, a, o, u) {
    r.push(o ? u.replace(pi, "$1") : a || t);
  }), r;
});
const hi = vi;
function St(e) {
  return e == null ? "" : dt(e);
}
function Z(e, r) {
  return A(e) ? e : No(e, r) ? [e] : hi(St(e));
}
var bi = 1 / 0;
function Se(e) {
  if (typeof e == "string" || He(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -bi ? "-0" : r;
}
function $t(e, r) {
  r = Z(r, e);
  for (var t = 0, a = r.length; e != null && t < a; )
    e = e[Se(r[t++])];
  return t && t == a ? e : void 0;
}
function rr(e, r) {
  for (var t = -1, a = r.length, o = e.length; ++t < a; )
    e[o + t] = r[t];
  return e;
}
var zr = x ? x.isConcatSpreadable : void 0;
function yi(e) {
  return A(e) || oe(e) || !!(zr && e && e[zr]);
}
function Ot(e, r, t, a, o) {
  var u = -1, f = e.length;
  for (t || (t = yi), o || (o = []); ++u < f; ) {
    var c = e[u];
    r > 0 && t(c) ? r > 1 ? Ot(c, r - 1, t, a, o) : rr(o, c) : a || (o[o.length] = c);
  }
  return o;
}
function mi(e) {
  var r = e == null ? 0 : e.length;
  return r ? Ot(e, 1) : [];
}
function wt(e) {
  return pt(ht(e, void 0, mi), e + "");
}
var _i = Et(Object.getPrototypeOf, Object);
const tr = _i;
var Ti = "[object Object]", Ei = Function.prototype, Si = Object.prototype, Rt = Ei.toString, $i = Si.hasOwnProperty, Oi = Rt.call(Object);
function Pt(e) {
  if (!L(e) || z(e) != Ti)
    return !1;
  var r = tr(e);
  if (r === null)
    return !0;
  var t = $i.call(r, "constructor") && r.constructor;
  return typeof t == "function" && t instanceof t && Rt.call(t) == Oi;
}
function Ct(e, r, t) {
  var a = -1, o = e.length;
  r < 0 && (r = -r > o ? 0 : o + r), t = t > o ? o : t, t < 0 && (t += o), o = r > t ? 0 : t - r >>> 0, r >>>= 0;
  for (var u = Array(o); ++a < o; )
    u[a] = e[a + r];
  return u;
}
function wi(e, r, t) {
  var a = e.length;
  return t = t === void 0 ? a : t, !r && t >= a ? e : Ct(e, r, t);
}
var Ri = "\\ud800-\\udfff", Pi = "\\u0300-\\u036f", Ci = "\\ufe20-\\ufe2f", Ai = "\\u20d0-\\u20ff", ji = Pi + Ci + Ai, xi = "\\ufe0e\\ufe0f", Ii = "\\u200d", Di = RegExp("[" + Ii + Ri + ji + xi + "]");
function At(e) {
  return Di.test(e);
}
function Fi(e) {
  return e.split("");
}
var jt = "\\ud800-\\udfff", Mi = "\\u0300-\\u036f", Ni = "\\ufe20-\\ufe2f", Li = "\\u20d0-\\u20ff", Ui = Mi + Ni + Li, Gi = "\\ufe0e\\ufe0f", Bi = "[" + jt + "]", Le = "[" + Ui + "]", Ue = "\\ud83c[\\udffb-\\udfff]", Wi = "(?:" + Le + "|" + Ue + ")", xt = "[^" + jt + "]", It = "(?:\\ud83c[\\udde6-\\uddff]){2}", Dt = "[\\ud800-\\udbff][\\udc00-\\udfff]", Yi = "\\u200d", Ft = Wi + "?", Mt = "[" + Gi + "]?", zi = "(?:" + Yi + "(?:" + [xt, It, Dt].join("|") + ")" + Mt + Ft + ")*", Hi = Mt + Ft + zi, Vi = "(?:" + [xt + Le + "?", Le, It, Dt, Bi].join("|") + ")", Ki = RegExp(Ue + "(?=" + Ue + ")|" + Vi + Hi, "g");
function qi(e) {
  return e.match(Ki) || [];
}
function Ji(e) {
  return At(e) ? qi(e) : Fi(e);
}
function ki(e) {
  return function(r) {
    r = St(r);
    var t = At(r) ? Ji(r) : void 0, a = t ? t[0] : r.charAt(0), o = t ? wi(t, 1).join("") : r.slice(1);
    return a[e]() + o;
  };
}
function Xi() {
  this.__data__ = new N(), this.size = 0;
}
function Zi(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
function Qi(e) {
  return this.__data__.get(e);
}
function eu(e) {
  return this.__data__.has(e);
}
var ru = 200;
function tu(e, r) {
  var t = this.__data__;
  if (t instanceof N) {
    var a = t.__data__;
    if (!ue || a.length < ru - 1)
      return a.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new U(a);
  }
  return t.set(e, r), this.size = t.size, this;
}
function K(e) {
  var r = this.__data__ = new N(e);
  this.size = r.size;
}
K.prototype.clear = Xi;
K.prototype.delete = Zi;
K.prototype.get = Qi;
K.prototype.has = eu;
K.prototype.set = tu;
function nu(e, r) {
  return e && X(r, _e(r), e);
}
function au(e, r) {
  return e && X(r, fe(r), e);
}
var Nt = typeof exports == "object" && exports && !exports.nodeType && exports, Hr = Nt && typeof module == "object" && module && !module.nodeType && module, ou = Hr && Hr.exports === Nt, Vr = ou ? D.Buffer : void 0, Kr = Vr ? Vr.allocUnsafe : void 0;
function Lt(e, r) {
  if (r)
    return e.slice();
  var t = e.length, a = Kr ? Kr(t) : new e.constructor(t);
  return e.copy(a), a;
}
function iu(e, r) {
  for (var t = -1, a = e == null ? 0 : e.length, o = 0, u = []; ++t < a; ) {
    var f = e[t];
    r(f, t, e) && (u[o++] = f);
  }
  return u;
}
function Ut() {
  return [];
}
var uu = Object.prototype, su = uu.propertyIsEnumerable, qr = Object.getOwnPropertySymbols, fu = qr ? function(e) {
  return e == null ? [] : (e = Object(e), iu(qr(e), function(r) {
    return su.call(e, r);
  }));
} : Ut;
const nr = fu;
function cu(e, r) {
  return X(e, nr(e), r);
}
var lu = Object.getOwnPropertySymbols, du = lu ? function(e) {
  for (var r = []; e; )
    rr(r, nr(e)), e = tr(e);
  return r;
} : Ut;
const Gt = du;
function gu(e, r) {
  return X(e, Gt(e), r);
}
function Bt(e, r, t) {
  var a = r(e);
  return A(e) ? a : rr(a, t(e));
}
function pu(e) {
  return Bt(e, _e, nr);
}
function Wt(e) {
  return Bt(e, fe, Gt);
}
var vu = V(D, "DataView");
const Ge = vu;
var hu = V(D, "Promise");
const Be = hu;
var bu = V(D, "Set");
const We = bu;
var Jr = "[object Map]", yu = "[object Object]", kr = "[object Promise]", Xr = "[object Set]", Zr = "[object WeakMap]", Qr = "[object DataView]", mu = H(Ge), _u = H(ue), Tu = H(Be), Eu = H(We), Su = H(Ne), W = z;
(Ge && W(new Ge(new ArrayBuffer(1))) != Qr || ue && W(new ue()) != Jr || Be && W(Be.resolve()) != kr || We && W(new We()) != Xr || Ne && W(new Ne()) != Zr) && (W = function(e) {
  var r = z(e), t = r == yu ? e.constructor : void 0, a = t ? H(t) : "";
  if (a)
    switch (a) {
      case mu:
        return Qr;
      case _u:
        return Jr;
      case Tu:
        return kr;
      case Eu:
        return Xr;
      case Su:
        return Zr;
    }
  return r;
});
const ar = W;
var $u = Object.prototype, Ou = $u.hasOwnProperty;
function wu(e) {
  var r = e.length, t = new e.constructor(r);
  return r && typeof e[0] == "string" && Ou.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var Ru = D.Uint8Array;
const et = Ru;
function or(e) {
  var r = new e.constructor(e.byteLength);
  return new et(r).set(new et(e)), r;
}
function Pu(e, r) {
  var t = r ? or(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var Cu = /\w*$/;
function Au(e) {
  var r = new e.constructor(e.source, Cu.exec(e));
  return r.lastIndex = e.lastIndex, r;
}
var rt = x ? x.prototype : void 0, tt = rt ? rt.valueOf : void 0;
function ju(e) {
  return tt ? Object(tt.call(e)) : {};
}
function Yt(e, r) {
  var t = r ? or(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var xu = "[object Boolean]", Iu = "[object Date]", Du = "[object Map]", Fu = "[object Number]", Mu = "[object RegExp]", Nu = "[object Set]", Lu = "[object String]", Uu = "[object Symbol]", Gu = "[object ArrayBuffer]", Bu = "[object DataView]", Wu = "[object Float32Array]", Yu = "[object Float64Array]", zu = "[object Int8Array]", Hu = "[object Int16Array]", Vu = "[object Int32Array]", Ku = "[object Uint8Array]", qu = "[object Uint8ClampedArray]", Ju = "[object Uint16Array]", ku = "[object Uint32Array]";
function Xu(e, r, t) {
  var a = e.constructor;
  switch (r) {
    case Gu:
      return or(e);
    case xu:
    case Iu:
      return new a(+e);
    case Bu:
      return Pu(e, t);
    case Wu:
    case Yu:
    case zu:
    case Hu:
    case Vu:
    case Ku:
    case qu:
    case Ju:
    case ku:
      return Yt(e, t);
    case Du:
      return new a();
    case Fu:
    case Lu:
      return new a(e);
    case Mu:
      return Au(e);
    case Nu:
      return new a();
    case Uu:
      return ju(e);
  }
}
function zt(e) {
  return typeof e.constructor == "function" && !Xe(e) ? _a(tr(e)) : {};
}
var Zu = "[object Map]";
function Qu(e) {
  return L(e) && ar(e) == Zu;
}
var nt = k && k.isMap, es = nt ? Qe(nt) : Qu;
const rs = es;
var ts = "[object Set]";
function ns(e) {
  return L(e) && ar(e) == ts;
}
var at = k && k.isSet, as = at ? Qe(at) : ns;
const os = as;
var is = 1, us = 2, ss = 4, Ht = "[object Arguments]", fs = "[object Array]", cs = "[object Boolean]", ls = "[object Date]", ds = "[object Error]", Vt = "[object Function]", gs = "[object GeneratorFunction]", ps = "[object Map]", vs = "[object Number]", Kt = "[object Object]", hs = "[object RegExp]", bs = "[object Set]", ys = "[object String]", ms = "[object Symbol]", _s = "[object WeakMap]", Ts = "[object ArrayBuffer]", Es = "[object DataView]", Ss = "[object Float32Array]", $s = "[object Float64Array]", Os = "[object Int8Array]", ws = "[object Int16Array]", Rs = "[object Int32Array]", Ps = "[object Uint8Array]", Cs = "[object Uint8ClampedArray]", As = "[object Uint16Array]", js = "[object Uint32Array]", m = {};
m[Ht] = m[fs] = m[Ts] = m[Es] = m[cs] = m[ls] = m[Ss] = m[$s] = m[Os] = m[ws] = m[Rs] = m[ps] = m[vs] = m[Kt] = m[hs] = m[bs] = m[ys] = m[ms] = m[Ps] = m[Cs] = m[As] = m[js] = !0;
m[ds] = m[Vt] = m[_s] = !1;
function he(e, r, t, a, o, u) {
  var f, c = r & is, l = r & us, y = r & ss;
  if (t && (f = o ? t(e, a, o, u) : t(e)), f !== void 0)
    return f;
  if (!I(e))
    return e;
  var p = A(e);
  if (p) {
    if (f = wu(e), !c)
      return gt(e, f);
  } else {
    var T = ar(e), w = T == Vt || T == gs;
    if (Ze(e))
      return Lt(e, c);
    if (T == Kt || T == Ht || w && !o) {
      if (f = l || w ? {} : zt(e), !c)
        return l ? gu(e, au(f, e)) : cu(e, nu(f, e));
    } else {
      if (!m[T])
        return o ? e : {};
      f = Xu(e, T, c);
    }
  }
  u || (u = new K());
  var C = u.get(e);
  if (C)
    return C;
  u.set(e, f), os(e) ? e.forEach(function(j) {
    f.add(he(j, r, t, j, e, u));
  }) : rs(e) && e.forEach(function(j, R) {
    f.set(R, he(j, r, t, R, e, u));
  });
  var G = y ? l ? Wt : pu : l ? fe : _e, ce = p ? void 0 : G(e);
  return vt(ce || e, function(j, R) {
    ce && (R = j, j = e[R]), Je(f, R, he(j, r, t, R, e, u));
  }), f;
}
function xs(e, r) {
  return e != null && r in Object(e);
}
function Is(e, r, t) {
  r = Z(r, e);
  for (var a = -1, o = r.length, u = !1; ++a < o; ) {
    var f = Se(r[a]);
    if (!(u = e != null && t(e, f)))
      break;
    e = e[f];
  }
  return u || ++a != o ? u : (o = e == null ? 0 : e.length, !!o && ke(o) && ye(f, o) && (A(e) || oe(e)));
}
function Ds(e, r) {
  return e != null && Is(e, r, xs);
}
function Fs(e) {
  return function(r, t, a) {
    for (var o = -1, u = Object(r), f = a(r), c = f.length; c--; ) {
      var l = f[e ? c : ++o];
      if (t(u[l], l, u) === !1)
        break;
    }
    return r;
  };
}
var Ms = Fs();
const qt = Ms;
function Ns(e, r) {
  return e && qt(e, r, _e);
}
function Ls(e, r) {
  return function(t, a) {
    if (t == null)
      return t;
    if (!se(t))
      return e(t, a);
    for (var o = t.length, u = r ? o : -1, f = Object(t); (r ? u-- : ++u < o) && a(f[u], u, f) !== !1; )
      ;
    return t;
  };
}
var Us = Ls(Ns);
const Gs = Us;
function Ye(e, r, t) {
  (t !== void 0 && !me(e[r], t) || t === void 0 && !(r in e)) && qe(e, r, t);
}
function Bs(e) {
  return L(e) && se(e);
}
function ze(e, r) {
  if (!(r === "constructor" && typeof e[r] == "function") && r != "__proto__")
    return e[r];
}
function Ws(e) {
  return X(e, fe(e));
}
function Ys(e, r, t, a, o, u, f) {
  var c = ze(e, t), l = ze(r, t), y = f.get(l);
  if (y) {
    Ye(e, t, y);
    return;
  }
  var p = u ? u(c, l, t + "", e, r, f) : void 0, T = p === void 0;
  if (T) {
    var w = A(l), C = !w && Ze(l), G = !w && !C && _t(l);
    p = l, w || C || G ? A(c) ? p = c : Bs(c) ? p = gt(c) : C ? (T = !1, p = Lt(l, !0)) : G ? (T = !1, p = Yt(l, !0)) : p = [] : Pt(l) || oe(l) ? (p = c, oe(c) ? p = Ws(c) : (!I(c) || Ke(c)) && (p = zt(l))) : T = !1;
  }
  T && (f.set(l, p), o(p, l, a, u, f), f.delete(l)), Ye(e, t, p);
}
function Jt(e, r, t, a, o) {
  e !== r && qt(r, function(u, f) {
    if (o || (o = new K()), I(u))
      Ys(e, r, f, t, Jt, a, o);
    else {
      var c = a ? a(ze(e, f), u, f + "", e, r, o) : void 0;
      c === void 0 && (c = u), Ye(e, f, c);
    }
  }, fe);
}
function zs(e) {
  var r = e == null ? 0 : e.length;
  return r ? e[r - 1] : void 0;
}
function Hs(e) {
  return typeof e == "function" ? e : Ve;
}
function kt(e, r) {
  var t = A(e) ? vt : Gs;
  return t(e, Hs(r));
}
function Vs(e, r) {
  return r.length < 2 ? e : $t(e, Ct(r, 0, -1));
}
var Ks = ki("toLowerCase");
const Xt = Ks;
var qs = La(function(e, r, t) {
  Jt(e, r, t);
});
const Js = qs;
function ks(e, r) {
  return r = Z(r, e), e = Vs(e, r), e == null || delete e[Se(zs(r))];
}
function Xs(e) {
  return Pt(e) ? void 0 : e;
}
var Zs = 1, Qs = 2, ef = 4, rf = wt(function(e, r) {
  var t = {};
  if (e == null)
    return t;
  var a = !1;
  r = lt(r, function(u) {
    return u = Z(u, e), a || (a = u.length > 1), u;
  }), X(e, Wt(e), t), a && (t = he(t, Zs | Qs | ef, Xs));
  for (var o = r.length; o--; )
    ks(t, r[o]);
  return t;
});
const tf = rf;
function nf(e, r, t, a) {
  if (!I(e))
    return e;
  r = Z(r, e);
  for (var o = -1, u = r.length, f = u - 1, c = e; c != null && ++o < u; ) {
    var l = Se(r[o]), y = t;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (o != f) {
      var p = c[l];
      y = a ? a(p, l, c) : void 0, y === void 0 && (y = I(p) ? p : ye(r[o + 1]) ? [] : {});
    }
    Je(c, l, y), c = c[l];
  }
  return e;
}
function af(e, r, t) {
  for (var a = -1, o = r.length, u = {}; ++a < o; ) {
    var f = r[a], c = $t(e, f);
    t(c, f) && nf(u, Z(f, e), c);
  }
  return u;
}
function of(e, r) {
  return af(e, r, function(t, a) {
    return Ds(e, a);
  });
}
var uf = wt(function(e, r) {
  return e == null ? {} : of(e, r);
});
const ot = uf, Zt = [
  "items",
  "showDuration",
  "showEasing",
  "visibleStyles",
  "hideDuration",
  "hideEasing",
  "hiddenStyles",
  "layout",
  "layoutOnResize",
  "layoutOnInit",
  "layoutDuration",
  "layoutEasing",
  "sortData",
  "dragEnabled",
  "dragHandle",
  "dragContainer",
  "dragStartPredicate",
  "dragAxis",
  "dragSort",
  "dragSortHeuristics",
  "dragSortPredicate",
  "dragRelease",
  "dragCssProps",
  "dragPlaceholder",
  "dragAutoScroll",
  "containerClass",
  "itemClass",
  "itemVisibleClass",
  "itemHiddenClass",
  "itemPositioningClass",
  "itemDraggingClass",
  "itemReleasingClass",
  "itemPlaceholderClass"
], Qt = [
  "onSynchronize",
  "onLayoutStart",
  "onLayoutEnd",
  "onLayoutAbort",
  "onAdd",
  "onRemove",
  "onShowStart",
  "onShowEnd",
  "onHideStart",
  "onHideEnd",
  "onFilter",
  "onSort",
  "onMove",
  "onSend",
  "onBeforeSend",
  "onReceive",
  "onBeforeReceive",
  "onDragInit",
  "onDragStart",
  "onDragMove",
  "onDragScroll",
  "onDragEnd",
  "onDragReleaseStart",
  "onDragReleaseEnd",
  "onDestroy"
], sf = [
  ...Zt,
  ...Qt
];
function ff() {
  var r;
  if (typeof ((r = window == null ? void 0 : window.document) == null ? void 0 : r.createElement) > "u" || document.querySelector("#ruuri-style") !== null)
    return;
  const e = document.createElement("style");
  e.id = "ruuri-style", e.innerHTML = `
    .ruuri-draggable-grid {
      position: relative;
    }
    
    .ruuri-draggable-item {
      user-select: none;
      position: absolute;
      z-index: 1;
      cursor: pointer;
    }
    
    .ruuri-draggable-item.muuri-item-positioning {
      z-index: 2;
    }
    
    .ruuri-draggable-item.muuri-item-dragging,
    .ruuri-draggable-item.muuri-item-releasing {
      z-index: 3;
    }
    
    .ruuri-draggable-item.muuri-item-dragging {
      cursor: move;
    }
    
    .ruuri-draggable-item.muuri-item-hidden {
      z-index: 0;
    }
  `, document.head.appendChild(e);
}
const cf = {
  dragEnabled: !0
};
function lf(e, r) {
  e && kt(r, (t, a) => {
    t && e.on(Xt(a.replace("on", "")), t);
  });
}
function df(e, r) {
  e && kt(r, (t, a) => {
    t && e.off(Xt(a.replace("on", "")), t);
  });
}
const gf = ut((e, r) => {
  const t = Ar(null), a = Ar(), o = jr(() => ot(e, Zt), [e]), u = jr(() => ot(e, Qt), [e]);
  return Dn(() => {
    if (!t.current)
      return;
    const f = new Mn(t.current, Js({}, cf, o));
    return a.current = f, lf(f, u), () => {
      df(f, u), f.destroy();
    };
  }, [u, o]), Fn(r, () => ({
    get grid() {
      return a.current;
    },
    get container() {
      return t.current;
    }
  })), Fe("div", { ref: t, ...tf(e, sf), className: Me("ruuri-draggable-grid", e.className) });
});
gf.displayName = "DraggableGrid";
ff();
const pf = ut(({ className: e, ...r }, t) => Fe("div", { className: Me("ruuri-draggable-item", "draggable-item"), children: Fe("div", { className: Me(e, "draggable-item-content"), ...r, ref: t }) }));
pf.displayName = "DraggableItem";
export {
  Qt as DRAGGABLE_GRID_EVENT_HANDLER_KEY_LIST,
  Zt as DRAGGABLE_GRID_OPTIONS_KEY_LIST,
  sf as DRAGGABLE_GRID_PROP_KEY_LIST,
  pf as DraggableItem,
  gf as default
};
